import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import axios from 'axios';

import logo01 from '../../assets/logos/cetificated.png';
import { Link } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const { token, currentUser } = useContext(AuthContext);

  const handleRecovery = async () => {
    const lang = 'es';
    if (!email) {
      setError('Email es requerido');
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/${lang}/auth/forgot-password`,
        { email }
      );
      if (response.status === 200) {
        alert(response.data.message);
      } else {
        alert(response.data.message);
      }
      setError('');
    } catch (error) {
      const { response } = error;
      setError('');
      alert(response.data.message);
    }
    setEmail('');
  };

  return (
    <>
      <div
        className="container-fluid bg-sen d-flex flex-column"
        style={{ minHeight: 'calc(100vh - 65px)' }}
      >
        <div className="row justify-content-center align-items-center flex-grow-1">
          <div className="col-12 col-md-4 col-lg-4 login">
            <div className="text-center">
              <img src={logo01} alt="Logo 1" className="logo mb-2" />
              <div className="clearfix"></div>
              <h2>Recuperar Contraseña</h2>
              <div className="text-start mb-2">
                Ingresa tu dirección de correo electrónico asociada a tu cuenta y te enviaremos
                instrucciones para restablecer tu contraseña.
              </div>
            </div>
            <div className="input-group mb-3">
              <span className="input-group-text bg-transparent border-end-0">
                <i className="fa fa-user"></i>
              </span>
              <input
                type="text"
                className="form-control bg-transparent border-start-0"
                id="email"
                placeholder="Email"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </div>
            <div className="">
              <div className="d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-light mt-1 mr-2"
                  onClick={() => (window.location.href = '/')}
                >
                  <span className="small">VOLVER AL LOGIN</span>
                </button>
                <button type="button" className="btn btn-dark mt-1" onClick={handleRecovery}>
                  <span className="small">ENVIAR</span>
                </button>
              </div>
            </div>

            {error && <p className="text-end">{error}</p>}
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
